export const analytics = {
  botWise: {
    botWiseAnalytics: 'Bot-Wise Analytics',
    currentBillingCycle: 'Trenutni obračunski ciklus',
    currentMonth: 'Trenutni mjesec',
    sinceAccountCreation: 'Od stvaranja računa',
    messages: 'Poruke',
    leads: 'Potencijalni kupci',
    noDataFound: {
      botwiseAnalytics: 'Bot-Wise Analytics',
      noBotHasBeenCreatedYet: 'Još nijedan bot nije stvoren!',
    },
    appTooltip: {
      TOOLTIP_BOTWISE_SUMMARY: 'Sažmite podatke iz poruka i kontakata/potencijalnih kupaca za određene botove za trenutni obračunski ciklus, trenutni mjesec ili od stvaranja računa (Ažurira se svaki ponoć)',
      TOOLTIP_FILTERS: 'Filtrirajte podatke za odabrani bota',
      TOOLTIP_MESSAGES: 'Ukupno poruka konzumirano od vašeg računa od stvaranja računa',
      TOOLTIP_LEADS: 'Ukupno potencijalnih kupaca koje su botovi uhvatili za vaš račun od stvaranja računa.',
    }
  },
  overview: {
    analytics: 'Analitika',
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    overview: 'Pregled',
    messages: 'Poruke',
    leads: 'Potencijalni kupci',
    appTooltip: {
      TOOLTIP_OVERVIEW_TITLE: 'Analitika za sve poruke i potencijalne kupce vaših botova. (Podaci se ažuriraju svaki ponoć)',
    }
  },
  summary: {
    analyticsSummary: 'Sažetak analitike',
    allBots: 'Svi botovi',
    daily: 'Dnevno',
    weekly: 'Tjedno',
    monthly: 'Mjesečno',
    messages: 'Poruke',
    leads: 'Potencijalni kupci',
    appTooltip: {
      TOOLTIP_ANALYTICS_SUMMARY: 'Sažmite dnevne, tjedne ili mjesečne podatke iz poruka i kontakata/potencijalnih kupaca za određene i sve botove (Ažurira se svaki ponoć)',
    }
  },
  whatsapp: {
    analyticsCount: {
      whatsappAnalytics: 'WhatsApp analitika',
      month: 'Mjesec',
      week: 'Tjedan',
      today: 'Danas',
      filters: 'Filteri',
      clearAll: 'Očisti sve',
      apply: 'Primijeni',
      totalConversations: 'Ukupni razgovori',
      freeConversations: 'Besplatni razgovori',
      paidConversations: 'Plaćeni razgovori',
      messageSent: 'Poslane poruke',
      messageDelivered: 'Dostavljene poruke',
      bpDropDown: {
        selectBot: 'Odaberite bota',
      },
      indexMergeDatePicker: {
        startDate: 'Početni datum',
        endDate: 'Završni datum',
      }
    },
    conversationAnalytics: {
      conversationAnalytics: 'Analitika razgovora',
      month: 'Mjesec',
      week: 'Tjedan',
      today: 'Danas',
      totalConversations: 'Ukupni razgovori',
      paidConversations: 'Plaćeni razgovori',
      freeConversations: 'Besplatni razgovori',
      indexMergeDatePicker: {
        startDate: 'Početni datum',
        endDate: 'Završni datum',
      },
      bpDropDown: {
        allBots: 'Svi botovi'
      }
    },
    messageAnalytics: {
      whatsappMessages: 'WhatsApp poruke',
      sent: 'Poslane',
      delivered: 'Dostavljene',
      indexMergeDatePicker: {
        startDate: 'Početni datum',
        endDate: 'Završni datum',
      },
      bpDropDown: {
        allBots: 'Svi botovi'
      },
      month: 'Mjesec',
      week: 'Tjedan',
      today: 'Danas',
    },
    messageStatusAnalytics: {
      whatsappMessagesByStatus: 'WhatsApp poruke prema statusu',
      sent: 'Poslane',
      delivered: 'Dostavljene',
      indexMergeDatePicker: {
        startDate: 'Početni datum',
        endDate: 'Završni datum',
      },
      bpDropDown: {
        allBots: 'Svi botovi'
      },
      month: 'Mjesec',
      week: 'Tjedan',
      today: 'Danas',
    },
    newWhatsappAnalytics: {
      allSubscribers: 'Svi pretplatnici',
      whatsappSubscribers: 'WhatsApp pretplatnici'
    }
  }
};
